/**
 * @generated SignedSource<<5817dbe70040d46616de3f86b996dc10>>
 * @relayHash 6530de33933ec959bd84c4787f04d944
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6530de33933ec959bd84c4787f04d944

import { ConcreteRequest } from 'relay-runtime';
export type NavigationTodoCountSubscription$variables = Record<PropertyKey, never>;
export type NavigationTodoCountSubscription$data = {
  readonly viewerTodoCount: number;
};
export type NavigationTodoCountSubscription = {
  response: NavigationTodoCountSubscription$data;
  variables: NavigationTodoCountSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "includeUnassignedEmployee",
        "value": true
      }
    ],
    "kind": "ScalarField",
    "name": "viewerTodoCount",
    "storageKey": "viewerTodoCount(includeUnassignedEmployee:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigationTodoCountSubscription",
    "selections": (v0/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "NavigationTodoCountSubscription",
    "selections": (v0/*: any*/)
  },
  "params": {
    "id": "6530de33933ec959bd84c4787f04d944",
    "metadata": {},
    "name": "NavigationTodoCountSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "70cf74822454ded1194d7b615ebce122";

export default node;
